import { getLog } from '../config';

const log = getLog('chantierVueMixin', 4, 1);

const chantierVueMixin = {
  data: () => ({
    chantierEdit: {
      id: 0, // READONLY PK integer
      title: '', // text db -> nom
      leader: '',
      description: '', // text
      commentaire: '', // text
      is_external: false, // READONLY boolean is true if it it is created outside goeland
      statut: null, // READONLY text statut from GOELAND
      identiteleader: null, // READONLY FK integer infered from iduser of who creates chantier
      entiteleader: '', // READONLY text entite from
      id_affaire_goeland: 0, // READONLY integer present only if affaire exist in goeland in VDL
      participants_vdl: '', // READONLY will always be readonly coming from goeland
      participantsVdlParsed: [],
      participantsExternal: [], // participants externes (pas de Lausanne) a ce chantier
      isplanifvalidated: false, // READONLY coming from goeland ?
      iduservalidator: 0, // READONLY integer saved in REST call
      datevalidation: '', // READONLY timestamp saved in REST call
      planified_date_begin: '', // date db -> planified_datestart
      planified_date_end: '', // date db -> planified_dateend
      real_date_begin: '', // date db -> real_datestart
      real_date_end: '', // date db -> real_dateend
      is_projet_definitif_en_cours: false, // for external use
      infos_complementaire_partenaire: '', // text
      datecreated: '', // READONLY timestamp db default now()
      idcreator: 0, // READONLY
      datelastmodif: '', // READONLY
      iduserlastmodif: '', // READONLY
      isactive: true, // READONLY
      dateinactivation: '', // READONLY timestamp
      isdeleted: false, // READONLY
      dateisdeleted: '', // READONLY
      commune_ofsid_intersects: '', // READONLY liste des num ofs commune intersectee
      commune_ofsid_contains: 0, // READONLY num ofs commune contenant integralement
      geom_wkt: '', // READONLY editing done in map control
      geom_GeoJSON: null,
      isNotRegistered: null, // RUNTIME TO TRACK IF CURRENT USER is not registerd with chanitier
      isLeader: false,
    },
    chantierDefault: {
      id: 0, // READONLY PK integer
      title: '', // text db -> nom REQUIRED
      leader: '',
      description: '', // text
      commentaire: '', // text
      is_external: false, // READONLY boolean is true if it it is created outside goeland
      statut: null, // READONLY text statut from GOELAND
      identiteleader: null, // READONLY if is_external=true FK iduser of chantier creator else null
      entiteleader: '', // READONLY text entite from Lausanne or Enterprise name from user table if is_external is true
      id_affaire_goeland: 0, // READONLY integer present only if affaire exist in goeland in VDL
      participants_vdl: '', // READONLY will always be readonly coming from goeland
      participantsVdlParsed: [],
      participantsExternal: [], // participants externes (pas de Lausanne) a ce chantier
      isplanifvalidated: false, // READONLY coming from goeland ?
      iduservalidator: 0, // READONLY integer saved in REST call
      datevalidation: '', // READONLY timestamp saved in REST call
      planified_date_begin: '', // date db -> planified_datestart
      planified_date_end: '', // date db -> planified_dateend
      real_date_begin: '', // date db -> real_datestart
      real_date_end: '', // date db -> real_dateend
      is_projet_definitif_en_cours: false, // for external use
      infos_complementaire_partenaire: '', // text
      datecreated: '', // READONLY timestamp db default now()
      idcreator: 0, // READONLY
      datelastmodif: '', // READONLY
      iduserlastmodif: '', // READONLY
      isactive: true, // READONLY
      dateinactivation: '', // READONLY timestamp
      isdeleted: false, // READONLY
      dateisdeleted: '', // READONLY
      commune_ofsid_intersects: '', // READONLY liste des num ofs commune intersectee
      commune_ofsid_contains: 0, // READONLY num ofs commune contenant integralement
      geom_wkt: '', // READONLY editing done in map control
      geom_GeoJSON: null,
      isNotRegistered: null, // RUNTIME TO TRACK IF CURRENT USER is not registerd with chantier
      isLeader: false,
    },
    chantierParticipeEdit: {
      id: 0,
      id_affaire: 0, // READONLY integer present only if affaire exist in goeland in VDL
      is_external: false, // READONLY boolean is true if it it is created outside goeland
      identiteleader: null, // READONLY FK iduser
      description: '', // text
      contact: '', // text
      datecreated: '', // READONLY timestamp db default now()
      idcreator: 0, // READONLY
      datelastmodif: '', // READONLY
    },
    chantierParticipeDefault: {
      id: 0,
      id_affaire: 0, // READONLY integer present only if affaire exist in goeland in VDL
      is_external: false, // READONLY boolean is true if it it is created outside goeland
      identiteleader: null, // READONLY FK iduser
      description: '', // text
      contact: '', // text
      datecreated: '', // READONLY timestamp db default now()
      idcreator: 0, // READONLY
      datelastmodif: '', // READONLY
    },
  }),

  props: {
  },

  computed: {
    formChantier() {
      return {
        title: this.chantierEdit.title,
        description: this.chantierEdit.description,
        commentaire: this.chantierEdit.commentaire,
        planified_date_begin: this.chantierEdit.planified_date_begin,
        planified_date_end: this.chantierEdit.planified_date_end,
        real_date_begin: this.chantierEdit.real_date_begin,
        real_date_end: this.chantierEdit.real_date_end,
        is_projet_definitif_en_cours: this.chantierEdit.is_projet_definitif_en_cours,
        infos_complementaire_partenaire: this.chantierEdit.infos_complementaire_partenaire,
        geom_wkt: this.chantierEdit.geom_wkt,
        participationContact: this.chantierParticipeEdit.contact,
      };
    },
  },
  created() {
    log.t('# IN mounted()');
  }, // end of mounted
  methods: {
    myfunc() {
      log.t('# IN myfunc()');
    },
  }, // end of methods
};

export default chantierVueMixin;
